import _ from 'lodash'
import devise from 'locales/devise.en.json'
import validates_timeliness from 'locales/validates_timeliness.en.json'

export default _.merge(devise, validates_timeliness).en



// WEBPACK FOOTER //
// ./src/locales/index.js